/**
 * State variations
 */
export var FORM_ELEMENT_STATES = [
    'error', 'warn', 'success',
];
